import { InitialValues } from 'forms/types';

import { HouseholdFormValues } from '../form/types';
import { GetHouseholdQuery } from '../graphql/GetHousehold';

const buildInitialValues = (data?: GetHouseholdQuery): InitialValues<HouseholdFormValues> => {
  const surveyHousehold = data?.surveyHousehold;

  return {
    spouseOrPartner: surveyHousehold?.spouseOrPartner ?? false,
    childrenOrPlanTo: surveyHousehold?.childrenOrPlanTo ?? false,
    buyingOrOwningHome: surveyHousehold?.buyingOrOwningHome ?? false,
    annualIncome: surveyHousehold?.annualIncome?.toString() ?? '',
    spouseAnnualIncome: surveyHousehold?.spouseAnnualIncome?.toString() ?? '',
  };
};

export default buildInitialValues;
